<div class="container mx-auto text-center">
  <span class="close" role="button" tabindex="0" aria-label="Sluiten" mat-dialog-close><mat-icon aria-hidden="true">close</mat-icon></span>
  <div class="justify-center items-center text-center">
    <img src="assets/images/logo-img.svg" alt="BeeFund" class="mx-auto"/>
    <h1 mat-dialog-title>{{ 'Wachtwoord vergeten' | translate }}</h1>
    <p>{{ 'Voer het e-mailadres van je account in en we e-mailen je een link om het wachtwoord opnieuw in te stellen.' | translate }}</p>
  </div>
  <form [formGroup]="forgotPasswordForm" (ngSubmit)="forgotPassword()" autocomplete="on">
    <div class="flex flex-col">
      <mat-form-field appearance="fill" floatLabel="auto">
        <mat-label>{{ 'E-mail' | translate }}</mat-label>
        <input matInput type="email" inputmode="email" spellcheck="false" name="email" autocomplete="email" [placeholder]="'E-mail'|translate" formControlName="email" id="email" required>
        <mat-error>
          <div *ngIf="email.invalid && email.errors.required">{{ 'E-mail is verplicht' | translate }}</div>
          <div *ngIf="email.invalid && !email.errors.required && email.errors.email">{{ 'E-mail is ongeldig' | translate }}</div>
        </mat-error>
      </mat-form-field>
    </div>
    <div class="flex flex-col justify-center items-center content-center margin-right-10">
      <button mat-raised-button type="submit" color="accent" [disabled]="forgotPasswordForm.invalid">{{'Resetlink sturen'|translate}}</button>
      <p><span>{{ 'Al een account?' | translate }}</span> <a role="button" tabindex="0" mat-dialog-close='login'>{{ 'Inloggen' | translate }}</a></p>
      <p><span>{{ 'Nog niet geregistreerd?' | translate }}</span> <a role="button" tabindex="0" mat-dialog-close='signUp'>{{ 'Registreren' | translate }}</a></p>
    </div>
  </form>
</div>